// src/pwa/utils/pwaInstalled.js
export function isStandalone() {
  // iOS Safari: navigator.standalone === true（ホーム画面起動のみ）
  // PWA全般: display-mode: standalone
  const mql = window.matchMedia?.('(display-mode: standalone)');
  return (window.navigator.standalone === true) || (!!mql && mql.matches);
}